import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import esTranslation from './locales/es.json';

i18n
    // .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: {},
        lng: 'EN',
        fallbackLng: 'EN',
        resources: {
            EN: {
                translation: enTranslation,
            },
            FR: {
                translation: frTranslation,
            },
            ES: {
                translation: esTranslation,
            },
        },
    });

export default i18n;
